import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { Spinner } from 'reactstrap';

const componentCache = new Map();

const LoadingSpinner = () => (
  <Spinner color="secondary" type="grow">
    Caricamento...
  </Spinner>
);

/**
 * Lazy-loads the given component and caches it by current route pathname so that
 * parent re-renders (e.g. auth/token refresh) don't remount and lose local state (e.g. open modals).
 * @param {() => Promise<{ default: React.ComponentType }>} component - lazy import function
 * @param {string} [cacheKey] - optional override for cache key (default: location.pathname)
 */
export default function AsyncComponent({ component, cacheKey }) {
  const location = useLocation();
  const key = cacheKey ?? location.pathname;

  if (!componentCache.has(key)) {
    componentCache.set(key, React.lazy(component));
  }

  const LazyComponent = componentCache.get(key);

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <LazyComponent />
    </Suspense>
  );
}
